import { ImageLazyProps } from './Image.types';
import { StyledPicture } from './Image.styles';
import { theme } from '../../styles';

import { constants, URL_CONSTANTS } from '../../constants';

export const ImageLazy = (props: ImageLazyProps) => {
  const { isLazy, url, sizes, title, appliedClass, fetchpriority, imageUrls, isImageCarousel, isVisible } = props;
  const { BASE_IMG_URL } = URL_CONSTANTS;
  const { IMG_ALT_TEXT, HIGH } = constants;
  const { wide, classic, square } = imageUrls || {};

  const image_urls = {
    largeDesktop: wide ? `${wide}${sizes?.xlarge}` : url ? `${url}${sizes?.xlarge}` : BASE_IMG_URL,
    desktop: wide ? `${wide}${sizes?.large}` : url ? `${url}${sizes?.large}` : BASE_IMG_URL,
    tablet: classic ? `${classic}${sizes?.medium}` : url ? `${url}${sizes?.medium}` : BASE_IMG_URL,
    mobile: square ? `${square}${sizes?.small}` : url ? `${url}${sizes?.small}` : BASE_IMG_URL,
  };

  const includeSrc = !isImageCarousel || isVisible;
  const includeDataSrc = isImageCarousel && !isVisible;

  return isLazy ? (
    <StyledPicture className="lazy">
      {sizes?.xlarge ? (
        <source media={theme.mediaQuery.largeDesktop} srcSet={BASE_IMG_URL} data-srcset={image_urls.largeDesktop} />
      ) : null}
      <source media={theme.mediaQuery.desktop} srcSet={BASE_IMG_URL} data-srcset={image_urls.desktop} />
      <source media={theme.mediaQuery.tabletOnly} srcSet={BASE_IMG_URL} data-srcset={image_urls.tablet} />
      <img
        src={BASE_IMG_URL}
        className={`image lazy ${appliedClass}`}
        alt={title ?? IMG_ALT_TEXT}
        data-src={image_urls.mobile}
        {...(fetchpriority !== HIGH && { loading: 'lazy' })}
        {...(fetchpriority && { fetchpriority: fetchpriority })}
      />
    </StyledPicture>
  ) : (
    <StyledPicture>
      {sizes?.xlarge ? (
        <source
          media={theme.mediaQuery.largeDesktop}
          {...(includeSrc && { srcSet: image_urls.largeDesktop })}
          {...(includeDataSrc && { 'data-srcset': image_urls.largeDesktop })}
        />
      ) : null}
      <source
        media={theme.mediaQuery.desktop}
        {...(includeSrc && { srcSet: image_urls.desktop })}
        {...(includeDataSrc && { 'data-srcset': image_urls.desktop })}
      />
      <source
        media={theme.mediaQuery.tabletOnly}
        {...(includeSrc && { srcSet: image_urls.tablet })}
        {...(includeDataSrc && { 'data-srcset': image_urls.tablet })}
      />
      <img
        className={`image ${appliedClass}`}
        alt={title ?? IMG_ALT_TEXT}
        {...(isImageCarousel && fetchpriority !== HIGH && { loading: 'eager' })}
        {...(includeSrc && { src: image_urls.mobile })}
        {...(includeDataSrc && { 'data-src': image_urls.mobile })}
        {...(fetchpriority && { fetchpriority: fetchpriority })}
      />
    </StyledPicture>
  );
};
